// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { CallingTheme } from '@azure/communication-react';
import { IFontStyles, PartialTheme } from '@fluentui/react';
import { pcpBluePalette, pcpGrayPalette, pcpRedPalette } from './palette';

/**
 * Preset light theme (v8) for components exported from this library.
 *
 * NOTE: this is actually the FL theme (blue gradient theme) from fima,
 * as we're currently using a single theme only.
 *
 * PCP theme is saved in a backup file.
 * We can use this later on in order to create a specialized PCP theme for the moderator app.
 *
 * NOTE 2: changing colors from green to blue is WIP.
 *
 * @public
 */
export const pcpComponentsLightTheme: PartialTheme & CallingTheme = {
  palette: {
    
    /** usages:
     * Primary button background color,
     * Text color of secondary button:hevered,
     */
    themePrimary: pcpBluePalette.foregroundDark, // #1088F9; The color should affect "colorBrandBackground" token via "createV9Theme";
    
    themeLighterAlt: '#fafcf4',
    themeLighter: '#e9f4d5',
    themeLight: pcpBluePalette.foregroundDarkAlternative,  // #7673FB, used as chat my-message background, as side-arrow (Caret) near my-message; The color should affect "colorBrandBackground2" token via "createV9Theme";
    themeTertiary: '#b3d770',
    themeSecondary: '#94c53a',
    themeDarkAlt: pcpBluePalette.foregroundDark,  // #1088F9;
    themeDark: '#678f1d',
    themeDarker: '#4c6a15',
    neutralLighterAlt: '#e9ecee',
    neutralLighter: '#e6e8ea',  //used as background of hovered button in "checked: true" state
    neutralLight: '#dcdee1',
    neutralQuaternaryAlt: pcpGrayPalette.grey82,  // #cdcfd1, used as 
    neutralQuaternary: '#c4c6c8',
    neutralTertiaryAlt: pcpGrayPalette.grey70, // #B3B6B9, used as dialog title text color.
    neutralTertiary: '#595959',
    neutralSecondary: '#373737',
    neutralPrimaryAlt: '#2f2f2f',
    neutralPrimary: '#000000',
    neutralDark: '#151515',
    black: '#0b0b0b',
    /** is used as background for: callConfiguration page, overlay menu-items */
    white: pcpGrayPalette.grey94, // #f0f2f4 == rgb(240, 242, 244)
    whiteTranslucent40: 'rgba(255, 255, 255, 0.4)',
  },
  callingPalette: {
    callRed: pcpRedPalette.foregroundDark,  //regular button, overriten in custom styles
    callRedDark: pcpRedPalette.foregroundDark,    //hovered button, overriten in custom styles
    callRedDarker: pcpRedPalette.foregroundDarker,      //pressed button, overriten in custom styles
    iconWhite: '#ffffff',
    raiseHandGold: '#f2c601',
    videoTileLabelBackgroundLight: 'rgba(255,255,255,0.8)'
  },
  semanticColors: {
    errorText: '#a80000',
    bodyBackground: pcpGrayPalette.grey94, //'#f0f2f4', it's used as callConfiguration page background color
  },
  // fonts: {
  //   mediumPlus: '1rem',
  // } as IFontStyles
};
